import {combineReducers} from 'redux';
import {authRiderReducer} from '../../../customerSignIn/store/reducers/authReducer'
import {AdminAuthRiderReducer} from '../../../adminSignIn/store/reducers/aminAuthReducer'
const reducer = combineReducers({
  authRiderReducer,AdminAuthRiderReducer 
    });
    
    export default reducer;
